import { api } from "../../lib/api";

// Public
export const getPlannerConfig = async () => (await api.get("/planner/config")).data;
export const calculatePlan = async (payload) => (await api.post("/planner/calculate", payload)).data;
export const savePlan = async (secret, payload, captchaToken = "") => (await api.post("/planner/plans", { secret, payload, captcha_token: captchaToken })).data;
export const unlockPlan = async (code, secret) => (await api.post(`/planner/plans/${code}/unlock`, { secret })).data;
export const updatePlan = async (code, secret, payload) => (await api.put(`/planner/plans/${code}`, { secret, payload })).data;
export const submitPlanToOth = async (code, secret, contact, captchaToken = "") => (await api.post(`/planner/plans/${code}/submit`, { secret, contact, captcha_token: captchaToken })).data;

const download = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
};

export const downloadExcel = async (payload) => {
    const res = await api.post("/planner/export/excel", payload, { responseType: "blob" });
    download(res.data, "oth-wealth-plan.xlsx");
};

export const downloadPdf = async (payload) => {
    const res = await api.post("/planner/export/pdf", payload, { responseType: "blob" });
    download(res.data, "oth-wealth-plan.pdf");
};

// Admin
export const getAdminTree = async () => (await api.get("/planner/admin/tree")).data;
export const addCategory = async (body) => (await api.post("/planner/admin/categories", body)).data;
export const editCategory = async (id, patch) => (await api.put(`/planner/admin/categories/${id}`, patch)).data;
export const addSubcategory = async (body) => (await api.post("/planner/admin/subcategories", body)).data;
export const editSubcategory = async (id, patch) => (await api.put(`/planner/admin/subcategories/${id}`, patch)).data;
export const reorderItems = async (kind, ids) => (await api.put("/planner/admin/reorder", { kind, ids })).data;
export const getAdminQuestions = async () => (await api.get("/planner/admin/questions")).data;
export const addQuestion = async (body) => (await api.post("/planner/admin/questions", body)).data;
export const editQuestion = async (id, patch) => (await api.put(`/planner/admin/questions/${id}`, patch)).data;
export const getAdminPlans = async () => (await api.get("/planner/admin/plans")).data;
export const getAdminPlanDetail = async (id) => (await api.get(`/planner/admin/plans/${id}`)).data;
export const getPlannerAnalytics = async (days) => (await api.get(`/planner/admin/analytics?days=${days}`)).data;
